// utils/dateUtils.js

export const formatUtcDate = (timestamp) => {
  if (!timestamp) return "N/A";

  const date = new Date(timestamp);

  // Format: "Wed Feb 05 2025"
  const datePart = date.toUTCString().split(" ").slice(0, 4).join(" ");

  // Format: "HH:mm:ss UTC"
  const timePart = new Intl.DateTimeFormat("en-GB", {
    timeZone: "UTC",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hour12: false,
  }).format(date) + " UTC";

  return `${datePart} ${timePart}`;
};

export const formatUtcDateSimple = (timestamp) => {
  console.log('formatUtcDateSimple input:', timestamp);
  
  if (!timestamp) return "N/A";
  
  try {
    // Handle both space and T separators
    const [datePart, timePart] = timestamp.includes('T') 
      ? timestamp.split('T')
      : timestamp.split(' ');
    
    console.log('Date parts:', { datePart, timePart });
    
    if (!datePart || !timePart) return "N/A";
    
    const [year, month, day] = datePart.split('-');
    const [hours, minutes, seconds] = timePart.split(':');
    
    console.log('Parsed date components:', { year, month, day, hours, minutes, seconds });
    
    if (!year || !month || !day) return "N/A";
    
    // Create date object in UTC
    const date = new Date(Date.UTC(
      parseInt(year), 
      parseInt(month) - 1, 
      parseInt(day), 
      parseInt(hours) || 0, 
      parseInt(minutes) || 0, 
      parseInt(seconds) || 0
    ));
    
    console.log('Created date object:', date);
    
    // Check if date is valid
    if (isNaN(date.getTime())) {
      console.log('Invalid date object');
      return "N/A";
    }
    
    // Format day name
    const dayNames = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
    const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    
    const dayName = dayNames[date.getUTCDay()];
    const monthName = monthNames[date.getUTCMonth()];
    
    // Format: "Mon Jun 02 2025"
    const formattedDate = `${dayName} ${monthName} ${day} ${year}`;
    
    // Format: "15:00:00 UTC"
    const formattedTime = `${hours || '00'}:${minutes || '00'}:${seconds || '00'} UTC`;
    
    const result = `${formattedDate} ${formattedTime}`;
    console.log('Final formatted result:', result);
    return result;
  } catch (error) {
    console.error('Error formatting date:', error);
    return "N/A";
  }
};